import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articleData } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50/80">
      {/* Top section */}
      <div className="px-6 md:px-10 lg:px-16 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1: Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <span className="text-background-50 font-heading text-sm font-bold">H</span>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                hoobuy<span className="text-accent-400">.beauty</span>
              </span>
            </Link>
            <p className="text-xs md:text-sm text-background-50/60 leading-relaxed max-w-xs">
              Plataforma informativa de curadoria de links do Hoobuy. Não vendemos produtos —
              apenas organizamos as melhores referências para suas compras internacionais.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Links Rápidos
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/artigo/guia-de-compras-hoobuy-2026" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  Guia de Compras
                </Link>
              </li>
              <li>
                <Link to="/artigo/guia-completo-hoobuyspreadsheet-2026" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  Guia Completo
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  Hoobuy Sheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Artigos */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Artigos
            </h4>
            <ul className="space-y-2.5">
              {articleData.slice(0, 6).map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/artigo/${a.slug}`}
                    className="text-sm text-background-50/70 hover:text-accent-400 transition-colors line-clamp-1"
                  >
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">
              Categorias
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/70 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Big Brand Text */}
      <div className="px-4 py-10 md:py-14 overflow-hidden">
        <p className="font-heading text-5xl md:text-8xl lg:text-9xl font-bold text-background-50/5 text-center tracking-tighter select-none whitespace-nowrap">
          HOOBUYSPREADSHEET
        </p>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-50/10 px-6 md:px-10 lg:px-16 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} hoobuy.beauty — Site informativo. Todos os direitos reservados.
          </p>
          <p className="text-xs text-background-50/30">
            Não vendemos produtos. Apenas curadoria de links.
          </p>
        </div>
      </div>
    </footer>
  );
}